import { Component, OnInit, Inject, OnDestroy, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { TrackingService } from '../../services/tracking.service';
import { PdfdataService } from '../../services/pdfdata.service';
import { AppState } from '../../app.reducer';
import { PersistFineService } from '../../services/persist.fine.service';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppLockSessionComponent } from '../../shared/app-lock-session/app-lock-session.component';
import { WINDOW } from '../../services/window.service';
import { FineModel } from '../../store/fine.model';
import { SetFineAction } from '../../store/fine.actions';
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';

/**
 * ViewfineComponent
 *
 * User Area, to show data fine
 */
@Component({
    selector: 'app-thankyou',
    templateUrl: './pending.component.html',
    styleUrls: []
})
export class PendingComponent implements OnInit, OnDestroy {

    /**
     * Session hash
     */
    private hash: string;

    /**
     * Param hash
     */
    private param_hash: string;

    /**
     * checksesInterval
     */
    private checksesInterval: any;

    /**
     * Fine data
     */
    public finedata: any;

    /**
     * Url Pdf of fine
     */
    public filePdfUrl: any;

    /**
     * Url Pdf of paid fine
     */
    public filePdfUrlPagado: any;

    /**
     * Url Pdf of justificantePagoOrganismo
     */
    public justificantePagoOrganismo: any;

    /**
     * modal that lock a session
     */
    @ViewChild('lockSession') private lockSession: AppLockSessionComponent;

    private subscription: Subscription = new Subscription();

    loading = true;

    params = {};
    public files = [];

    /**
     * @ignore
     */
    constructor(private http: HttpClient,
                private router: Router,
                private route: ActivatedRoute,
                private apiService: ApiService,
                private authService: AuthService,
                @Inject(DOCUMENT) private _document,
                @Inject(WINDOW) private window: Window,
                private translate: TranslateService,
                private trackingService: TrackingService,
                private pdfdataService: PdfdataService,
                private store: Store<AppState>,
                private persistFineService: PersistFineService,
                private location: Location) {

        this.hash = this.authService.getHash();

        this.route.params.subscribe(params => {
            this.param_hash = params['hash'];
        });
    }

    /**
     * Using api Service get fine data on init and check state, set URL PDF, and dates of comunications
     */
    ngOnInit() {
        this.files = JSON.parse(localStorage.getItem('expedientes'));
        this.route.queryParams
            .subscribe(params => {
                    this.params = params;
                    this.setPendingState();
                }
            );

        // if session hash is different from hash of route eject from session to login page.
        if (this.hash !== this.param_hash) {
            return false;
        }

        this.checksesInterval = setInterval(() => {
            this.hash = this.authService.getHash();
            if (this.hash !== this.param_hash) {
                clearInterval(this.checksesInterval);
                return false;
            }

        }, 1000 * 60);


        this.apiService.getFineData(`${this.hash}`,`${this.files[0]}`)
            .subscribe((response: any) => {
                    this.finedata = response;

                    // escape caracteres before persist data
                    let lugar: string;
                    if (this.finedata.lugar != null) {
                        lugar = this.finedata.lugar.replace(/[^\w\s]/gi, ' ');
                    } else {
                        lugar = this.finedata.lugar;
                    }

                    let cliente: string;
                    if (this.finedata.cliente != null) {
                        cliente = this.finedata.cliente.replace(/[^\w\s]/gi, ' ');
                    } else {
                        cliente = this.finedata.cliente;
                    }


                    // store
                    const fineObject = new FineModel({
                        rolAcceso: this.finedata.rolAcceso,
                        rolPermiso: this.finedata.rolPermiso,
                        acceso: this.finedata.acceso,
                        cliente: cliente,
                        contrato: this.finedata.contrato,
                        fechaInicioContrato: this.finedata.fechaInicioContrato,
                        fechaFinContrato: this.finedata.fechaFinContrato,
                        expedienteGesthispania: this.finedata.expedienteGesthispania,
                        nombreOrganismo: this.finedata.nombreOrganismo,
                        codigoSancion: this.finedata.codigoSancion,
                        lugar: lugar,
                        matricula: this.finedata.matricula,
                        tipoInfraccion: this.finedata.tipoInfraccion,
                        estado: this.finedata.estado,
                        fechaFinEnlace: this.finedata.fechaFinEnlace,
                        importeAPagar: this.finedata.importeAPagar,
                        importePagado: this.finedata.importePagado,
                        idEnlace: this.finedata.idEnlace,
                        pagoActivo: this.finedata.pagoActivo,
                    });

                    // PDF Fine
                    this.pdfdataService.setURLPdf(response.ficheroMulta, 'fine');
                    this.filePdfUrl = this.pdfdataService.getURLPdf('fine');
                    this.filePdfUrlPagado = this.pdfdataService.getURLPdf('paidfine');

                    this.store.dispatch(new SetFineAction(fineObject));
                    this.persistFineService.persistData(fineObject);


                },
                error => {

                    this.errorEvent(error.status, error.message);
                    this.authService.logout();
                    this.router.navigate([`/app/login/pyf/${this.hash}`], {queryParams: {error: error.status}});


                });
    }

    /**
     * @ignore
     */
    ngOnDestroy() {
        clearInterval(this.checksesInterval);
        this.subscription.unsubscribe();
    }

    /**
     * @ignore
     */
    viewpdf(type, event) {
        this.router.navigate([`/app/viewpdf/${type}/${this.hash}/${this.finedata.expedienteGesthispania}`]);
        // this.myEvent(event);
    }

    /**
     * Captures component event and sends event data to analytics.
     */
    myEvent(event) {
        if (this.trackingService.getPermissionTracking() === 'all' || this.trackingService.getPermissionTracking() === 'statistics') {

            this.trackingService.setHash(this.hash);

            this.trackingService.actionEvent(event, 'SHOW_FINE');

            // Google Analytics
            const idElement: string = (event.target as Element).id;
            const typeEvent: string = event.type;
            const eventAction: string = 'idelement: ' + idElement + ' - typeEvent: ' + typeEvent;
            // (<any>window).ga('send', 'event', {
            //     eventCategory: 'Thank You Page Events',
            //     eventLabel: 'ThankYouEvents',
            //     eventAction: eventAction,
            //     eventValue: 10
            // });
        }

    }

    /**
     * Captures component error event and saves it in localstorage using tracking service and sends error event data to analytics.
     */
    errorEvent(status, message) {
        if (this.trackingService.getPermissionTracking() === 'all' || this.trackingService.getPermissionTracking() === 'statistics') {

            this.trackingService.setHash(this.hash);

            this.trackingService.errorEvent(status, message);

            // Google Analytics
            const eventAction: string = 'error message: ' + message + ' - error code status: ' + status;
            // (<any>window).ga('send', 'event', {
            //     eventCategory: 'Thank You Page Error Events',
            //     eventLabel: 'ThankYouPageErrorEvents',
            //     eventAction: eventAction,
            //     eventValue: 10
            // });

        }
    }

    viewFine() {
        const hash = this.authService.getHash();
        this.router.navigate([`app/finegroup/${hash}`]);
        // if (JSON.parse(localStorage.getItem('expedientes')).length > 1) {
        //     this.router.navigate([`app/finegroup/${hash}`]);
        // } else {
        //     this.router.navigate([`app/viewfine/${hash}`]);
        // }
    }

    setPendingState() {
        const URL_API = environment.URL_API;
        const url = URL_API + 'respuestastripe/mercedespt/' + this.authService.getHash();
        const datos = {
            'codigo': localStorage.getItem('codigo'),
            'client_secret': this.params['client_secret'],
            'livemode': this.params['livemode'],
            'redirect_status': this.params['redirect_status'],
            'source': this.params['source'],
            'expedientes': this.files
        };
        const headers: HttpHeaders = new HttpHeaders().set('TOKEN', this.authService.getToken());
        return this.http.post<any>(url, datos, {headers}).subscribe(
            data => {
                this.loading = false;
            },
            error => {
                this.loading = false;
            }
        );
    }

}
